import React, {useState, useEffect} from 'react';
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from '../../../UiComponents/SBADrawer';
import { SBAComboBox } from '../../../UiComponents/SBADropDown';
import { 
  getPartnership, 
  getPartnershipPortfolio ,
  insertPartnership
} from '../../../../config/apiConfig';
import { sbaAxios } from '../../../utils/sbaAxios';
import moment from 'moment';
import { toast } from 'react-toastify';

const PartnershipStep = ({selectedPartnership, handleSelectedPartnership}) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const [portfolioList, setPortfolioList] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [partnershipName, setPartnershipName] = useState('');
    const [gridData, setGridData] = useState([]);
    const [isPartnersListFetched, setIsPartnersListFetched] = useState(false);

    const fetchPartnerships = async() => {
      try{
        const list = await sbaAxios({
          url:getPartnership
        });
        setGridData(list?.map((item)=>{
          return {...item, selected :false }
        }));
        setIsPartnersListFetched(true);
      }
      catch(e){
        setGridData([]);
        setIsPartnersListFetched(false);
      }
    }
    useEffect(()=>{
      fetchPartnerships();
    },[]);

    const fetchPortfolioList = async() => {
      try{
        const list = await sbaAxios({
          url:getPartnershipPortfolio
        });
        setPortfolioList(list);
      }
      catch(e){
        setPortfolioList([]);
      };
    };

    const savePartnership = async() => {
      setIsPartnersListFetched(false);
      if (!selectedPortfolio) {
        toast.error('Please Select a Portfolio');
        return;
      }
      if (!partnershipName) {
        toast.error('Please enter the Partnership Name');
        return;
      }
      try{
        const dateIsoString = new Date().toISOString();
        const res = await sbaAxios({
            url:insertPartnership + "/" + selectedPortfolio.PortfolioId + "/" + partnershipName + "/" + dateIsoString,
            method:'post'
        });
        if(res === -2){
          toast.error('Partnership already exists.');
          return;
        }
        toast.success('Partnership added successfully');
      }
      catch(e){
        toast.error('Unable to add Partnership');
      }
      finally{
        setShowDrawer(false);
        fetchPartnerships();
      };
    }

    useEffect(()=>{
        if(isPartnersListFetched){
          const updatedGrid = gridData.map((row) => {
              if(row.PartnershipId === selectedPartnership?.PartnershipId){
                  row.selected = selectedPartnership?.selected
              }
              return row;
          })
          setGridData(updatedGrid);
        }
    },[selectedPartnership, isPartnersListFetched]);
    const colDefs = [
        {headerName:'Partnership Name', field:'PartnershipName'},
        //{headerName:'Short Name', field:'shortName'},
        {headerName:'Portfolio Name', field:'PortfolioName'},
        {
          headerName:'Date', 
          field:'StartDate',
          valueFormatter: (params) => {
            if (!params.value) return ""; // Handle cases where the date is null or undefined
            return moment(params.value).format("MM/DD/YYYY");
          },
        },
        {
            headerName:'Action', 
            field:'selected', 
            cellRenderer: 'agCheckboxCellRenderer',
            cellRendererParams: {
                checkbox: true,
            },
            editable: true,
            width: 100,
        }
    ];

    const onCellValueChanged = (params) => {
        if (params.colDef.field === 'selected' && params.newValue) {
          const updatedData = gridData.map((row) => ({
            ...row,
            selected: row.PartnershipId === params.data.PartnershipId,
          }));
    
          handleSelectedPartnership(params.data);
          setGridData(updatedData);
        }
    };

    return(
      <>
        <div className='container-fluid' style={{paddingTop:0, marginTop:'20px'}}>
            <div className="h4">Partnership</div>
            <div className='row d-flex justify-content-end' style={{ marginRight:'65px' }}>
            <button
                type="submit"
                className="p-sm-btn"
                onClick={() => {
                  setShowDrawer(true);
                  fetchPortfolioList();
                }}
                style={{width:'75px'}}
            >
            Add
            </button>
            </div>
            <div className='row w-100'>
            <div
                className="row my-4"
                style={{ height: "500px", width: "100%" }}
            >
              <div className="row col-12 h-100">
                <div
                  className="ag-theme-alpine"
                  style={{ height: "100%", width: "100%", paddingTop: 0 }}
                >
                  <AgGridReact
                    rowData={gridData}
                    columnDefs={colDefs}
                    rowSelection="single"
                    onCellValueChanged={onCellValueChanged}
                    defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }}
                  />
                </div>
              </div>
            </div>
            </div>
        </div>
        <SBADrawer
          open={showDrawer}
          setOpen={setShowDrawer}
          close={false}
          title={"Add New Partnership"}
        >
          <div className="row ">
            <div className="col-md-6">
              <div className='d-flex flex-column'>
                <label className="label">Portfolio</label>
                <SBAComboBox
                    data={portfolioList}
                    textField={"PortfolioName"}
                    valueField={"PortfolioId"}
                    value={selectedPortfolio}
                    onChange={(e)=>setSelectedPortfolio(e.value)}
                    popupSettings={{ className: "modalDD" }}
                    style={{width:"250px"}}
                ></SBAComboBox>
              </div>
            </div>
            <div className="col-md-6">
              <div>
                <label className="label">Partnership Name</label>
                <input
                  className="w-125 input-default form-control"
                  type="text"
                  Value={partnershipName}
                  onChange={(e)=> setPartnershipName(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="m-1 d-flex justify-content-end mt-2">
            <button className="s-sm-btn mx-1" onClick={()=>setShowDrawer(false)}>Cancel</button>
            <button className="p-sm-btn mx-1" onClick={savePartnership}>Add</button>
          </div>
        </SBADrawer>
      </>              
    );
};


export default PartnershipStep;